(() => {
  window.LPMPreviewProfiles = window.LPMPreviewProfiles || {};

  const braceletCordonDesktopSlots = {
    1: [
      { x: 246, y: 337, r: 0 }
    ],
    2: [
      { x: 162, y: 310, r: 4 },
      { x: 324, y: 335, r: -4 }
    ],
    3: [
      { x: 35, y: 185, r: 40 },
      { x: 246, y: 337, r: 0 },
      { x: 475, y: 240, r: -40 }
    ],
    4: [
      { x: 20, y: 190, r: 50 },
      { x: 152, y: 310, r: 10 },
      { x: 340, y: 335, r: -10 },
      { x: 488, y: 230, r: -50 }
    ],
    5: [
      { x: 10, y: 174, r: 60 },
      { x: 100, y: 290, r: 30 },
      { x: 215, y: 332, r: 10 },
      { x: 360, y: 325, r: -30 },
      { x: 485, y: 245, r: -50 }
    ],
    6: [
      { x: 17, y: 4, r: 105 },
      { x: 20, y: 190, r: 55 },
      { x: 150, y: 310, r: 10 },
      { x: 340, y: 330, r: -10 },
      { x: 488, y: 230, r: -55 },
      { x: 505, y: 50, r: -105 }
    ],
    7: [
      { x: 20, y: 15, r: 105 },
      { x: 10, y: 174, r: 60 },
      { x: 100, y: 290, r: 30 },
      { x: 215, y: 332, r: 10 },
      { x: 360, y: 325, r: -30 },
      { x: 485, y: 245, r: -50 },
      { x: 525, y: 70, r: -105 }
    ]
  };

  const braceletCordonMobileSlots = {
    1: [
      { x: 105, y: 212, r: 0 }
    ],
    2: [
      { x: 48, y: 195, r: 8 },
      { x: 160, y: 212, r: -8 }
    ],
    3: [
      { x: -36, y: 119, r: 40 },
      { x: 105, y: 212, r: 0 },
      { x: 253, y: 147, r: -40 }
    ],
    4: [
      { x: -46, y: 118, r: 50 },
      { x: 46, y: 195, r: 8 },
      { x: 166, y: 210, r: -8 },
      { x: 267, y: 138, r: -50 }
    ],
    5: [
      { x: -48, y: 114, r: 50 },
      { x: 20, y: 185, r: 20 },
      { x: 97, y: 210, r: 0 },
      { x: 175, y: 208, r: -20 },
      { x: 262, y: 147, r: -50 }
    ],
    6: [
      { x: -47, y: -10, r: 105 },
      { x: -46, y: 118, r: 50 },
      { x: 38, y: 190, r: 8 },
      { x: 166, y: 208, r: -8 },
      { x: 267, y: 138, r: -50 },
      { x: 280, y: 20, r: -105 }
    ],
    7: [
      { x: -46, y: -8, r: 105 },
      { x: -45, y: 110, r: 50 },
      { x: 20, y: 185, r: 20 },
      { x: 97, y: 210, r: 0 },
      { x: 175, y: 208, r: -20 },
      { x: 262, y: 147, r: -50 },
      { x: 290, y: 27, r: -105 }
    ]
  };

  window.LPMPreviewProfiles["bracelet-cordon"] = {
    desktop: braceletCordonDesktopSlots,
    mobile: braceletCordonMobileSlots,
    charmWidthDesktop: 155,
    charmWidthMobile: 120
  };

  const braceletChaineTromboneGrandeDesktopSlots = {
     1: [
      { x: 240, y: 435, r: 0 }
    ],
    2: [
      { x: 165, y: 433, r: 4 },
      { x: 324, y: 427, r: -4 }
    ],
    3: [
      { x: 130, y: 412, r: 20 },
      { x: 240, y: 435, r: 0 },
      { x: 360, y: 410, r: -4 }
    ],
    4: [
      { x: 90, y: 400, r: 30 },
      { x: 240, y: 435, r: 0 },
      { x: 360, y: 410, r: -4 },
      { x: 488, y: 280, r: -50 }
    ],
    5: [
      { x: -30, y: 270, r: 60 },
      { x: 90, y: 410, r: 30 },
      { x: 240, y: 435, r: 0 },
      { x: 360, y: 410, r: -4 },
      { x: 488, y: 280, r: -50 }
    ],
    6: [
      { x: -35, y: 200, r: 60 },
      { x: 30, y: 350, r: 30 },
      { x: 200, y: 435, r: 0 },
      { x: 360, y: 410, r: -4 },
      { x: 488, y: 280, r: -50 },
      { x: 480, y: 80, r: -105 }
    ],
    7: [
      { x: -25, y: 90, r: 105 },
      { x: -30, y: 270, r: 60 },
      { x: 90, y: 400, r: 30 },
      { x: 220, y: 435, r: 0 },
      { x: 360, y: 410, r: -4 },
      { x: 488, y: 280, r: -70 },
      { x: 490, y: 90, r: -105 }
    ]
  };
  const braceletChaineTromboneGrandeMobileSlots = {
  1: [
    { x: 105, y: 235, r: 0 }
  ],

  2: [
    { x: 64, y: 230, r: 4 },
    { x: 152, y: 230, r: -4 }
  ],

  3: [
    { x: 25, y: 215, r: 20 },
    { x: 105, y: 235, r: 0 },
    { x: 190, y: 218, r: -20 }
  ],

  4: [
    { x: -20, y: 180, r: 40 },
    { x: 64, y: 230, r: 10 },
    { x: 152, y: 230, r: -10 },
    { x: 238, y: 167, r: -50 }
  ],

  5: [
    { x: -38, y: 158, r: 60 },
    { x: 25, y: 215, r: 20 },
    { x: 105, y: 235, r: 0 },
    { x: 190, y: 218, r: -20 },
    { x: 245, y: 160, r: -60 }
  ],

  6: [
    { x: -48, y: 121, r: 60 },
    { x: -20, y: 180, r: 40 },
    { x: 64, y: 230, r: 10 },
    { x: 152, y: 230, r: -10 },
    { x: 238, y: 167, r: -50 },
    { x: 255, y: 65, r: -105 }
  ],

  7: [
    { x: -52, y: 58, r: 105 },
    { x: -38, y: 158, r: 60 },
    { x: 25, y: 215, r: 20 },
    { x: 105, y: 235, r: 0 },
    { x: 190, y: 218, r: -20 },
    { x: 245, y: 160, r: -60 },
    { x: 256, y: 58, r: -105 }
  ]
};

  window.LPMPreviewProfiles["bracelet-chaine-trombone-grande"] = {
    desktop: braceletChaineTromboneGrandeDesktopSlots,
    mobile: braceletChaineTromboneGrandeMobileSlots,
    charmWidthDesktop: 180,
    charmWidthMobile: 120,
    mobileBreakpoint: 749
  };
})();
